import store from '@/store/index.js';
import request from '@/utils/request'

// 获取一级分类
export function getProductSort(params) {
	return request({
		url: 'procurement/system/front/category/list',
		params
	})
}

// 获取分类商品
export function search(params) {
	return request({
		url: 'procurement/system/front/search',
		params
	})
}

// 获取单品详情
export function getProInfo(params) {
	return request({
		url: 'procurement/system/front/product/productList',
		params
	})
}

// 获取专题详情
export function getPmsProductBaseBySubjectId(params) {
	return request({
		url: 'procurement/system/front/subject/getPmsProductBaseBySubjectId',
		params
	})
}

/**
 * 2023-02-03 董浩
 * 获取热词
 */
export function getHtWords() {
	return request({
		url: 'procurement/system/front/pms-hot-words/all?size=5&pages=1'
	})
}

/**
 * 2023-02-03 董浩
 * 获取首页全部分类
 */
export function getAllTypes() {
	return request({
		url: 'procurement/system/front/category/listAll'
	})
}

/**
 * 2023-02-03 董浩
 * 获取首页底部楼层数据
 */
export function getHomeProductList() {
	return request({
		url: 'procurement/system/front/subject/subjectAreaAll?specialArea=1&type=0'
	})
}

/**
 * 2023-02-06 董浩
 * 获取购物车列表
 */
export function getCartList(isNotUpdateStore) {
	return request({
		url: 'procurement/system/front/oms-cart-items/list'
	}).then(res => {
		if (res && res.code == '0' && res.data && res.data.items && !isNotUpdateStore) {
			store.commit("SET_CARTLIST", res.data.items);
		}
		
		return res;
	});
}

/**
 * 2023-02-07 董浩
 * 加购、更新购物车
 */
export function updateCartData(params) {
	return request({
		url: 'procurement/system/front/oms-cart-items/add',
		method: 'PUT',
		params
	}).then(res => {
		if (res && res.code == 0 && res.data && res.data.items) {
			store.commit("SET_CARTLIST", res.data.items);
		}
		
		return res;
	});
}

/**
 * 2023-02-07 董浩
 * 批量加购、更新购物车
 */
export function batchUpdateCartData(isCheck, data) {
	let url = 'procurement/system/front/oms-cart-items/batch?isCheck=' + isCheck
	if (!isCheck) url = `${url}&minus=true`
	return request({
		url: url,
		method: 'PUT',
		data
	}).then(res => {
		if (res && res.code == 0 && res.data && res.data.items) {
			store.commit("SET_CARTLIST", res.data.items);
		}
		
		return res;
	});
}

/**
 * 2023-02-07 董浩
 * 删除购物车
 */
export function delCartData(params) {
	return request({
		url: 'procurement/system/front/oms-cart-items/clear',
		method: 'DELETE',
		params
	}).then(res => {
		if (res && res.code == 0 && res.data && res.data.items) {
			store.commit("SET_CARTLIST", res.data.items);
		}
		
		return res;
	});
}

/**
 * 2023-02-07 乔宁
 * 近期下单
 */
export function recentPurchase(params) {
	return request({
		url: 'procurement/system/front/product/recentPurchase',
		params
	})
}

/**
 * 2023-11-14 董浩
 * 批量加购、更新购物车
 */
export function importCartData(data) {
	return request({
		url: 'procurement/system/front/oms-cart-items/v2/batch',
		method: 'PUT',
		data
	}).then(res => {
		if (res && res.code == 0 && res.data && res.data.items) {
			store.commit("SET_CARTLIST", res.data.items);
		}
		
		return res;
	});
}

/**
 * 2025-07-02 李超
 * 服务器时间
 */
export function serverTimeApi() {
	return request({
		url: 'procurement/system/front/home/time',
		method: 'get',
	})
}

/**
 * 2025-07-02 李超
 * 限时抢购
 */
export function panicBuyingApi(params) {
	return request({
		url: 'procurement/system/front/sms-activitys/getFlashSaleDetails',
		method: 'get',
		params
	})
}

/**
 * 2025-07-02 李超
 * 凑单
 */
export function groupOrderApi(params) {
	return request({
		url: '/procurement/system/front/product/fullDiscount/list',
		method: 'get',
		params
	})
}

/**
 * 2025-07-02 李超
 * 优惠券列表
 */
export function couponListApi(params) {
	return request({
		url: '/procurement/system/front/product/couPonProduct/list',
		method: 'get',
		params
	})
}